import { TranslationSchema } from "../types/translations";
import { languageStringsAdmin } from "./hu/admin";
import { languageStringsCampaign } from "./hu/campaign";
import { languageStringsContact } from "./hu/contact";
import { languageStringsPopups } from "./hu/popup";
import { languageStringsSubscriptions } from "./hu/subscriptions";

export const hu: TranslationSchema = {
  sidePanel: {
    campaign: "Kampány",
    connection: "Összekapcsolás",
    settings: "Beállítások",
    infinite: "korlátozások nélkül",
  },
  noTariffBanner: {
    title: "Az Ön fiókja nem tartalmaz semmilyen aktív díjcsomagot",
    description:
      "Aktív díjcsomag nélkül nem tudunk a konverziós arány növelése érdekében értesítéseket megjeleníteni a weboldalán.",
    button1: "Díjcsomag aktiválása",
    button2: "az első 14 napra ingyen",
  },
  noPixelBanner: {
    title: "A weboldalon nincs beillesztve pixel script.",
    description: "Az értesítések működéséhez illessze be a pixel scriptet",
    button: "Hogyan illessze be a pixelt?",
  },
  apiKeysTitle: "Integráció – elégedett ügyfelek véleményeinek megjelenítése",
  zboziApiChangeNotice: "Figyelmeztetés: A Zboží.cz API-t az új Sklik API váltotta fel. Ha Zboží.cz integrációja van, frissítenie kell az API-kulcsát – az új refresh tokent a sklik.cz oldalon, a Beállítások → API-kulcsok menüpontban kaphatja meg.",
  addingApiKeys: "API kulcsok hozzáadása",
  optionalAddApiKey:
    "Ez a lépés opcionális. Az API kulcsokat később is hozzáadhatja",
  login: "Bejelentkezés",
  monthlyCredits: "Hátralévő havi kreditek",
  portableCredits: "Extra megvásárolt kreditek",
  extraCredits: "További megvásárolt kreditek",
  help: "Súgó",
  reportProblem: "Hiba bejelentése",
  saveChanges: "Változtatások mentése",
  reset: "Reset",
  defaultSettings: "Kezdeti beállítások",
  addKey: "Kulcs hozzáadása",
  back: "Vissza",
  choose: "Választás",
  extraCreditsPage: {
    buttonText: "Vásárlás",
    shows: "megtekintés",
    navigationButtonText: "Vásárlás hozzáadása",
    purchaseError:
      "Nem sikerült elindítani a fizetést. Kérjük, próbálja meg később, vagy lépjen kapcsolatba az ügyfélszolgálattal.",
  },
  close: "Bezárás",
  delete: "Törlés",
  yes: "Igen",
  verified: "Ellenőrizve",
  notVerified: "Nem ellenőrizve",
  connected: "Összekapcsolva",
  active: "Aktív",
  inactive: "Inaktív",
  check: "Ellenőrzés",
  add: "Hozzáadás",
  edit: "Módosítás",
  save: "Mentés",
  continue: "Tovább",
  userIsNotLoggedIn: "A felhasználó nincs bejelentkezve",
  deleteWebsite: "Webhely törlése",
  spolehliveRecenze: "Spolehlivé Recenze",
  logout: "Kijelentkezés",
  paymentFailed: {
    title: "A fizetés törölve",
    description: "A fizetés nem fejeződött be.",
    continue: "Próbálja újra",
  },
  paymentRejected: {
    title: "A fizetés elutasításra került",
    description: "A fizetést nem fogadták el. Kérjük, próbálja újra.",
    continue: "Folytatás",
  },
  notFound: {
    title: "Nem találtuk a kért oldalt",
    back: "Vissza",
  },
  loggedOut: {
    title: "Kijelentkezett",
    description: "Bezárhatja az oldalt",
    close: "Oldal bezárása",
  },
  passwordChange: {
    title: "Jelszó megváltoztatása",
    setPasswordTitle: "Jelszó beállítása",
    oldPassword: "Jelenlegi jelszó",
    newPassword: "Új jelszó",
    password: "Jelszó",
    confirmPassword: "Új jelszó megerősítése",
    passwordMismatch: "A jelszavak nem egyeznek",
    passwordSet: "A jelszó beállítva, kérjük, jelentkezzen be újra.",
    passwordSetFailed: "Nem sikerült beállítani a jelszót",
    passwordChanged: "A jelszó megváltozott, kérjük, jelentkezzen be újra.",
    passwordChangeFailed: "Nem sikerült megváltoztatni a jelszót",
    errors: {
      passwordsDoNotMatch: "A jelszavak nem egyeznek",
      failedToChange: "Nem sikerült megváltoztatni a jelszót",
    },
    success: "A jelszó megváltozott, kérjük, jelentkezzen be újra.",
  },
  onBoarding: {
    title: "Adja hozzá az első webhelyét",
    description:
      "Ne aggódjon, végigvezetjük minden lépésen. Hamarosan élvezheti a Hiteles Web által nyújtott előnyöket.",
    start: "Kezdés",
    logout: "Kijelentkezés",
    errors: {
      websiteNameTaken: "Ez a weboldalnév már foglalt",
      fillAllFields: "Töltse ki az összes mezőt",
      enterApiKey: "Adja meg az API kulcsot",
      enterCredentials: "Adja meg a felhasználónevet és jelszót",
    },
    apiKeyModal: {
      added: "Hozzáadva.",
      notVerified: "Nincs ellenőrizve",
      zbozi: {
        noAccessToPremise: "Az API-kulcsnak nincs hozzáférése ehhez a telephelyhez. Lehetséges okok: (1) A kulcs egy másik Sklik-fiókhoz tartozik, nem ahhoz, amely kezeli ezt a telephelyet. (2) A telephelyen nincs aktív konverziókövetés a Zboží.cz-n – ez szükséges az értékelések API használatához. Konverziókövetés beállítása: zbozi.cz/mereni-konverzi",
        invalidApiKey: "Az API-kulcs érvénytelen vagy lejárt. Hozzon létre új kulcsot a Sklik Beállítások → API-kulcsok menüpontban.",
        insufficientPermissions: "Az API-kulcsnak nincs elegendő jogosultsága. Hozzon létre új kulcsot a Skliken a Zboží.cz / Nákupy adatokhoz való joggal.",
        verificationFailed: "Az ellenőrzés sikertelen. Kérjük, ellenőrizze az API-kulcsot és a telephely azonosítóját.",
      },
    },
  },
  resetPassword: {
    title: "Jelszó visszaállítása",
    reset: "Visszaállítás",
    emailSent: "Ha létezik fiók ezzel az e-mail címmel, megkapja a jelszó-visszaállítási utasításokat.",
    newPassword: "Új jelszó",
    confirmPassword: "Jelszó megerősítése",
    submit: "Jelszó visszaállítása",
    backToLogin: "Vissza a bejelentkezéshez",
    success: "Jelszó sikeresen visszaállítva",
    successMessage: "A jelszavát visszaállítottuk. Minden munkamenet kijelentkeztetésre került. Most már bejelentkezhet az új jelszavával.",
    invalidLink: "Érvénytelen link",
    errorTitle: "Érvénytelen visszaállítási link",
    errorMessage: "Ez a link érvénytelen vagy lejárt. Kérjen új jelszó-visszaállítási linket.",
    passwordTooShort: "A jelszónak legalább 8 karakterből kell állnia",
    passwordsMismatch: "A jelszavak nem egyeznek",
    genericError: "Nem sikerült visszaállítani a jelszót. Kérjük, próbálja újra.",
    description: "Adja meg új jelszavát",
    redirecting: "Átirányítás a bejelentkezéshez",
  },
  deleteWeb: {
    title: "Törli a webhelyet?",
    description: "Minden adat és kampány törlésre kerül.",
    delete: "Törlés",
    close: "Bezárás",
  },
  loginScreen: {
    title: "Bejelentkezés",
    email: "Email",
    password: "Jelszó",
    button: "Bejelentkezés",
    newUsers: "Új felhasználó?",
    forgotPassword: "Elfelejtette a jelszavát?",
    resetPassword: "Visszaállítás",
    signUp: "Regisztráljon",
  },
  registrationScreen: {
    title: {
      first: "Csak egy lépésre van",
      second: "a konverziós arány növelésétől",
      third: "webáruházának",
      fourth: "akár 20%-kal!",
    },
    subTitle:
      "Töltse ki az alábbi adatokat és csatlakozzon a sikeres webáruház-tulajdonosokhoz",
    name: "Név",
    phone: "Telefonszám (opcionális)",
    email: "Email",
    password: "Jelszó",
    confirmPassword: "Jelszó megerősítése",
    accept: "Elfogadom a",
    terms: "feltételeket",
    button: "REGISZTRÁCIÓ BEFEJEZÉSE",
    alreadyHaveAccount: "Van már fiókja?",
    login: "Bejelentkezés",
  },
  addWebsite: {
    title: "Webhely hozzáadása",
    name: "Webhely neve",
    warning: "Adja meg a weboldal teljes URL-címét, beleértve a https-t is.",
    includeHttps: "https-sel együtt",
    url: "Webhely URL",
    notificationLanguage: "Értesítések nyelve",
    czech: "Cseh",
    slovak: "Szlovák",
    polish: "Lengyel",
  },
  howToInstallPixel: {
    title: "Pixel telepítése",
    first: "Másolja ki a Pixel kódot.",
    second: "Illessze be a kódot a webhelye fejlécébe a </head> előtt.",
    third:
      "Látogasson el az oldalára a pixel kód aktiválásához. Ezután ellenőrizze az „Ellenőrzés„ gombbal.",
    help: "Hogyan illesszem be a pixel kódot a weboldalra?",
  },
  websites: {
    title: "Összes megtekintése",
    website: "Webhely",
    created: "Létrehozva",
    campaigns: "Kampányok",
    addWebsite: "Webhely hozzáadása",
    connect: "Összekapcsolás",
    connected: "Összekapcsolva",
    yourWebsites: "Az Ön webhelyei",
    addButton: "Hozzáadás",
    backButton: "Vissza",
  },
  iconSelect: {
    selectedIcon: "Kiválasztott ikon",
    selectIcon: "Kattintson az ikon kiválasztásához",
    dialogTitle: "Válasszon ikont",
    dialogClose: "Bezár",
  },
  settingsTabs: {
    webSettings: "Alapbeállítások",
    customLogo: "Egyéni logó",
  },
  customLogo: {
    showLogo: "Logó megjelenítése",
    logo: "Logó",
    text: "Szöveg",
    textColor: "Szöveg színe",
    save: "Mentés",
  },
  shoptetFirstTouchScreen: {
    title: "A bővítmény telepítése sikeres volt.",
    description1:
      "Számos okos értesítést készítettünk az Ön webáruháza számára, amelyek a hasonló webáruházak esetében szerzett tapasztalataink szerint a leghatékonyabban növelik webáruháza megrendelései számát. Ezek automatikusan elindulnak. Közvetlenül az ingyenes próbaút aktiválása után.",
    description2:
      "Kattintson a gombra. Aktiválja az okos értesítéseket, és már csak figyelje, hogyan nőnek napról-napra a megrendelései.",
    button: "Ingyenes 14 napos próbaverzió futtatása",
    error: "A bejelentkezés sikertelen, jelentkezzen ki és próbálja meg újra.",
  },
  webarealFirstTouchScreen: {
    title: "A bővítmény telepítése sikeres volt.",
    description1:
      "Számos okos értesítést készítettünk az Ön webáruháza számára, amelyek a hasonló webáruházak esetében szerzett tapasztalataink szerint a leghatékonyabban növelik webáruháza megrendelései számát. Ezek automatikusan elindulnak. Közvetlenül az ingyenes próbaút aktiválása után.",
    description2:
      "Kattintson a gombra. Aktiválja az okos értesítéseket, és már csak figyelje, hogyan nőnek napról-napra a megrendelései.",
    button: "Ingyenes 14 napos próbaverzió futtatása",
    error: "A bejelentkezés sikertelen, jelentkezzen ki és próbálja meg újra.",
  },
  eshopRychleFirstTouchScreen: {
    title: "Üdvözöljük az Ellenőrzött Weboldalban!",
    description1: "Fiókja sikeresen létrehozva.",
    description2: "Kérjük, állítson be jelszót az adminisztrációhoz való hozzáféréshez.",
    button: "Jelszó beállítása",
    error: "A bejelentkezés sikertelen. Kérjük, próbálja újra.",
  },
  upgatesFirstTouchScreen: {
    title: "A bővítmény telepítése sikeres volt.",
    description1:
      "Számos okos értesítést készítettünk az Ön webáruháza számára, amelyek a hasonló webáruházak esetében szerzett tapasztalataink szerint a leghatékonyabban növelik webáruháza megrendelései számát. Ezek automatikusan elindulnak. Közvetlenül az ingyenes próbaút aktiválása után.",
    description2:
      "Kattintson a gombra. Aktiválja az okos értesítéseket, és már csak figyelje, hogyan nőnek napról-napra a megrendelései.",
    button: "Ingyenes 14 napos próbaverzió futtatása",
    error: "A bejelentkezés sikertelen, jelentkezzen ki és próbálja meg újra.",
  },
  shopifyFirstTouchScreen: {
    title: "Az alkalmazás telepítése sikeres volt!",
    description1:
      "Számos okos értesítést készítettünk az Ön Shopify áruháza számára, amelyek a hasonló áruházak esetében szerzett tapasztalataink szerint a leghatékonyabban növelik megrendelései számát. Ezek automatikusan elindulnak az ingyenes próbaút aktiválása után.",
    description2:
      "Kattintson a gombra az okos értesítések aktiválásához, és figyelje, hogyan nőnek napról-napra a megrendelései.",
    button: "Ingyenes 14 napos próbaverzió futtatása",
    error: "A bejelentkezés sikertelen. Kérjük, próbálja meg újra.",
  },
  trustPilot: {
    businessUnitId: "Üzleti egység azonosító",
    apiKey: "API kulcs",
    apiSecret: "API titkos kulcs",
    reviews: "értékelés",
    reviewsWithRating: "Értékelések több mint",
    stars: "csillaggal",
    maxReviews: "Megjelenítendő értékelések minimális száma",
    verificationPrompt:
      "Kérjük, ellenőrizze a TrustPilot API kulcsát és az üzleti egység azonosítóját",
    sourceUrlAddress: "Adja meg az üzleti egység azonosítóját",
  },
  errors: {
    pixelCheckFailed: "Az automatikus pixel ellenőrzés nem volt sikeres.",
    placesApiError: "Hiba történt a Google Maps adatok betöltése során. Kérjük, vegye fel velünk a kapcsolatot segítségért.",
    userNotFound: "A megadott e-mail címmel rendelkező felhasználó nem létezik",
    userAlreadyExists: "A megadott e-mail címmel már létezik felhasználó",
    fillAllFields: "Kérjük, töltse ki az összes kötelező mezőt",
    passwordsDoNotMatch: "A jelszavak nem egyeznek",
    termsRequired: "El kell fogadnia a felhasználási feltételeket",
    invalidEmail: "Kérjük, adjon meg érvényes e-mail címet",
    logoFileTooLarge: "A logó túl nagy. A maximális méret {{maxSize}} KB, az Ön fájlja {{actualSize}} KB.",
    logoFileTooLargeSimple: "A logó túl nagy. A maximális fájlméret 100 KB.",
    failedToLoadSettings: "Nem sikerült betölteni a beállításokat",
    // Backend error types
    Generic: "Váratlan hiba történt",
    Unauthorized: "Nincs jogosultsága ehhez a művelethez",
    Unhandled: "Kezeletlen hiba",
    NotEnoughCredits: "Nincs elegendő kreditje",
    IntegrityHashNotFound: "A munkamenet lejárt, kérjük, jelentkezzen be újra",
    ErrorVerifyingAccessToken: "Hiba a hozzáférési token ellenőrzésekor",
    MissingAccessToken: "Hiányzik a hozzáférési token",
    AccessTokenExpired: "A hozzáférési token lejárt",
    InvalidCredentials: "Érvénytelen bejelentkezési adatok",
    UserEmailAlreadyExists: "Ezzel az e-mail címmel már létezik felhasználó",
    EmailNotSent: "Nem sikerült elküldeni az e-mailt, kérjük, próbálja újra később",
    ItemNotFound: "Az elem nem található",
    WebsiteNotFound: "A weboldal nem található",
    UserNotFound: "A felhasználó nem található",
    CampaignNotFound: "A kampány nem található",
    NotificationSettingsNotFound: "Az értesítési beállítások nem találhatók",
    ParameterBadFormat: "Érvénytelen paraméter formátum",
    QueryStringMissing: "Hiányzó URL paraméter",
    BodyParameterMissing: "Hiányzó kérés paraméter",
    EnvVarNotFound: "Hiányzó konfigurációs változó",
    PricingPlanNotFoundInStripe: "Az árképzési terv nem található a Stripe-ban",
    PricingPlanInconsistencyInStripe: "Árképzési terv inkonzisztencia a Stripe-ban",
    PriceNotFoundInStripe: "Az ár nem található a Stripe-ban",
    CustomerNotFoundInStripe: "Az ügyfél nem található a Stripe-ban",
    SubscriptionInconsistencyInStripe: "Előfizetés inkonzisztencia a Stripe-ban",
    SubscriptionNotFoundInStripe: "Az előfizetés nem található a Stripe-ban",
    PricingPlanCreditsNotFound: "Az árképzési terv kreditjei nincsenek beállítva",
    StripeWebhookError: "Stripe webhook hiba",
    CustomerDeletedInStripe: "Az ügyfél törölve van a Stripe-ban",
    UnexpectedStripeInvoicePayload: "Váratlan adatok a Stripe-tól",
    StripeSessionUrlError: "Stripe fizetési munkamenet URL hiba",
    ThirdPartyApiError: "Külső API hiba",
    UserWithoutPasswordError: "A felhasználónak nincs beállított jelszava, valószínűleg külső rendszeren keresztül regisztrált",
    PrivateKeyDoesNotMatch: "A privát kulcs nem egyezik",
    UserNotDeletedInStripe: "A felhasználó nem lett törölve a Stripe-ból",
    InvalidRequestBody: "Érvénytelen kérés formátum",
    UserNotRegisteredThroughWebareal: "A felhasználó nem a Webareal-on keresztül regisztrált",
    WebarealWebsiteAlreadyExists: "Ez a Webareal e-shop már regisztrálva van",
    UserNotRegisteredThroughUpgates: "A felhasználó nem az Upgates-en keresztül regisztrált",
    RedisClientNotFound: "Redis kliens nem található",
    PayloadTooLarge: "A kérés túl nagy",
  },
  cancelSubscription: {
    title: "Biztosan meg szeretné szüntetni az előfizetés megújítását?",
    confirmButton: "Igen, megszüntetem",
    cancelButton: "Vissza",
  },
  admin: languageStringsAdmin,
  campaign: languageStringsCampaign,
  subscriptions: languageStringsSubscriptions,
  contact: languageStringsContact,
  popups: languageStringsPopups,
};
